import { inject, Injector } from '@angular/core';

import { createProviderToken, provide } from '@core/common-legacy';
import { HttpApiService } from '@core/http-legacy';
import { HttpApiRequestOptions, HttpRequestData } from '@core/http-types';

import { TellentAdminRequestData } from './tellent-admin-request-data';

export class TellentIntelligenceRequestData extends TellentAdminRequestData {
  public buildUrl(path: string, requestOptions: HttpApiRequestOptions): string {
    return `${this.config.tellentApiUrl}${
      requestOptions.skipCompany ? '' : '/intelligence/org/' + this.orgGuid
    }${path}`;
  }
}

export const { inject: injectTellentIntelligenceHttp } = createProviderToken(
  'TellentIntelligenceHttp',
)(false, {
  providedIn: 'root',
  factory: () =>
    Injector.create({
      providers: [
        provide(HttpApiService, { useClass: HttpApiService }),
        provide(HttpRequestData, { useClass: TellentIntelligenceRequestData }),
      ],
      parent: inject(Injector),
    }).get(HttpApiService),
});
